<form [formGroup]="form" *ngIf="entity && entity.visibleToUser" novalidate>
  @if(!templateForPermitForm){
  <div [ngClass]="divClass">
    <wm-de-label [entity]="entity" [for]="entity.templateCode"></wm-de-label>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">$</span>
      </div>
      <input
        *ngIf="!entity.isCalculating"
        type="number"
        [readonly]="!entity.isEditable"
        [ngClass]="inputClass"
        [formControlName]="entity.templateCode"
        [(ngModel)]="modelValue"
        [name]="entity.templateCode"
        [id]="entity.templateCode"
      />
      <app-loader *ngIf="entity.isCalculating"></app-loader>
    </div>
  </div>
  }@else {
  <div [ngClass]="divClass">
    <wm-de-label [entity]="entity" [for]="entity.templateCode"></wm-de-label>
    <div class="input-group mb-3">
      <!-- <div class="input-group-prepend">
        <span class="input-group-text">$</span>
      </div> -->
      <!-- <wm-common-angular-textfield
        *ngIf="!entity.isCalculating"
        [formControlName]="entity.templateCode"
        [name]="entity.templateCode"
        [id]="entity.templateCode"
        [(ngModel)]="modelValue"
        [type]="'number'"
        [isEditable]="entity.isEditable"
      ></wm-common-angular-textfield> -->
      <wm-common-textfield
        *ngIf="!entity.isCalculating"
        [data]="{
          id: entity.templateCode,
          required: true,
          readonly: !entity.isEditable,
          value: modelValue,
          prefix: '$' 
        }"
        [formControlName]="entity.templateCode"
        (valueChange)="modelValue = $event"
      >
      </wm-common-textfield>

      <app-loader *ngIf="entity.isCalculating"></app-loader>
    </div>
  </div>

  }
</form>
